import { Vocabulary } from "../Vocabulary";
import DashboardIcon from "@mui/icons-material/Dashboard";
import { localUrlEnum } from "../urlEnum";
import AssignmentIcon from "@mui/icons-material/Assignment";

export const ROUTER_VIN_REQUESTS = {
  routes: [
    "/",
    "/vehiclesDashboard/vehicleDashboard/:id?",
    "/tasksDashboard",
    localUrlEnum.reports,
    localUrlEnum.vinRequests,
    "*",
  ],
};

export const MAIN_SLIDER_VIN_REQUESTS = [
  {
    name: Vocabulary.vinRequests,
    path: localUrlEnum.vinRequests,
    icon: <AssignmentIcon />,
    orderId: 12,
  },
];

export const VEHICLE_VIN_REQUESTS = [
  {
    name: Vocabulary.dashboard,
    path: `/vehiclesDashboard/vehicleDashboard/`,
    icon: <DashboardIcon />,
    id: "vehicleDashboard",
    orderNumber: 0,
  },
];

export const VEHICLES_VIN_REQUESTS = [1, 2, 3, 4];

export const DINAMIC_TABS_VIN_REQUESTS = null;

export const MAIN_TABLE_VIN_REQUESTS = null;
